import { useEffect } from 'react'
import { IconDirectorChair } from '../icons'

export default function PartyDirectorReveal({ party, onContinue }) {
  // Auto-advance when director finishes reveal:
  // - 'team_setup' for most modes
  // - 'actor_pick' for battle-royale (skips team setup)
  useEffect(() => {
    if (party?.status === 'team_setup' || party?.status === 'actor_pick') {
      onContinue?.()
    }
  }, [party?.status]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!party) {
    return (
      <div className="party-director-reveal">
        <p style={{ color: 'var(--text-muted)' }}>Loading...</p>
      </div>
    )
  }

  const director = party.directorId ? party.players?.[party.directorId] : null
  const initial = (director?.username || '?').charAt(0).toUpperCase()

  return (
    <div className="party-director-reveal">
      {/* CSS confetti burst using pseudo-elements defined in App.css */}
      <div className="party-director-reveal__confetti" aria-hidden="true" />

      <div className="party-director-reveal__chair" aria-hidden="true">
        <IconDirectorChair size={20} />
      </div>
      <p className="party-director-reveal__teaser">And your Director is...</p>

      {director && (
        <>
          <div className="party-director-reveal__avatar">
            {director.avatar
              ? <img src={director.avatar} alt={director.username} />
              : <span className="party-avatar__initial">{initial}</span>}
          </div>
          <p className="party-director-reveal__name">
            {director.username || 'Guest'}
          </p>
        </>
      )}

      <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: 8 }}>
        Waiting for Director to continue...
      </p>
    </div>
  )
}
